export default __webpack_public_path__ + "static/background3-5ec33c00abffe054a8f78e2aed291c9d.png";